module.exports = __webpack_public_path__ + "img/20190712164713305.3fe8f1b5.png";